/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { BigNumberDependencies } from './dependenciesBigNumberClass.generated.js';
import { createEfimovFactor } from '../../factoriesAny.js';
export var efimovFactorDependencies = {
  BigNumberDependencies,
  createEfimovFactor
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesEfimovFactor.generated.js
// module id = 1353
// module chunks = 2